import {
  Permission,
  isPermissionType,
} from "@p0security/shared/types/permission";
import { Typography } from "@p0security/ui";
import { AllIntegrationLogos } from "components/Integrations/IntegrationLogo";
import {
  directories,
  resourceIntegrations,
} from "components/Integrations/constants";
import { useFlags } from "launchdarkly-react-client-sdk";
import { cloneDeep } from "lodash";
import { useMemo } from "react";

import { requestLocator } from "../requestUtils";

export const PermissionLocation: React.FC<{
  permission: Permission;
}> = ({ permission }) => {
  const flags = useFlags();

  const integrationMap = useMemo(
    () => [
      ...cloneDeep(resourceIntegrations(flags)),
      ...cloneDeep(directories(flags)),
    ],
    [flags]
  );

  const location = requestLocator(permission);
  return (
    isPermissionType(permission.type) && (
      <>
        {AllIntegrationLogos[permission.type]}{" "}
        <Typography.Text code>
          {location
            ? String(location)
            : integrationMap.find((i) => i.key === permission.type)?.label}
        </Typography.Text>
      </>
    )
  );
};
